import scheduleApi from '@/api/schedule-api'

const state = {
  schedule: {},
  schedules: [],
  totalSchedules: 0,
  scheduleGroups: [],
  totalScheduleGroups: 0,
  scheduleGroupUsers: [],
}

const mutations = {
  setSchedule(state, val) {
    state.schedule = val
  },
  setSchedules(state, val) {
    state.schedules = val
  },
  setTotalSchedules(state, val) {
    state.totalSchedules = val
  },
  setScheduleGroups(state, val) {
    state.scheduleGroups = val
  },
  setTotalScheduleGroups(state, val) {
    state.totalScheduleGroups = val
  },
  setScheduleGroupUsers(state, val) {
    state.scheduleGroupUsers = val
  },
}

const actions = {
  async listSchedules({ commit }, filters) {
    commit('app/loading', true, { root: true })
    await scheduleApi.list(filters).then(
      response => {
        commit('setSchedules', response.data.data || response.data)
        commit('setTotalSchedules', response.data.meta ? response.data.meta.total[1] : response.data.total || 0)
        commit('app/loading', false, { root: true })
      },
      () => {
        commit('app/loading', false, { root: true })
        commit('notifications', { title: 'Error al obtener el listado de horarios.', variant: 'danger' }, { root: true })
        commit('setShowNotifications', true, { root: true })
      },
    )
  },
  async getSchedule({ commit }, id) {
    commit('app/loading', true, { root: true })
    await scheduleApi.show(id).then(
      response => {
        commit('setSchedule', response.data.data || response.data)
        commit('app/loading', false, { root: true })
      },
      () => {
        commit('app/loading', false, { root: true })
        commit('notifications', { title: 'Error al obtener el horario.', variant: 'danger' }, { root: true })
        commit('setShowNotifications', true, { root: true })
      },
    )
  },
  async createSchedule({ commit }, data) {
    commit('app/loading', true, { root: true })
    await scheduleApi.store(data).then(
      () => {
        commit('notifications', { title: 'Horario creado con éxito.', variant: 'success' }, { root: true })
        commit('setShowNotifications', true, { root: true })
        commit('app/loading', false, { root: true })
      },
      () => {
        commit('app/loading', false, { root: true })
        commit('notifications', { title: 'Error al crear el horario.', variant: 'danger' }, { root: true })
        commit('setShowNotifications', true, { root: true })
      },
    )
  },
  async updateSchedule({ commit }, { id, data }) {
    commit('app/loading', true, { root: true })
    await scheduleApi.update(id, data).then(
      () => {
        commit('notifications', { title: 'Horario actualizado con éxito.', variant: 'success' }, { root: true })
        commit('setShowNotifications', true, { root: true })
        commit('app/loading', false, { root: true })
      },
      () => {
        commit('app/loading', false, { root: true })
        commit('notifications', { title: 'Error al actualizar el horario.', variant: 'danger' }, { root: true })
        commit('setShowNotifications', true, { root: true })
      },
    )
  },
  async createGroupSchedule({ commit }, data) {
    commit('app/loading', true, { root: true })
    await scheduleApi.storeGroup(data).then(
      () => {
        commit('notifications', { title: 'Agrupación creada con éxito.', variant: 'success' }, { root: true })
        commit('setShowNotifications', true, { root: true })
        commit('app/loading', false, { root: true })
      },
      () => {
        commit('app/loading', false, { root: true })
        commit('notifications', { title: 'Error al crear la agrupación.', variant: 'danger' }, { root: true })
        commit('setShowNotifications', true, { root: true })
      },
    )
  },
  async listScheduleGroups({ commit }, filters) {
    commit('app/loading', true, { root: true })
    await scheduleApi.listGroups(filters).then(
      response => {
        commit('setScheduleGroups', response.data.data || response.data)
        commit('setTotalScheduleGroups', response.data.meta ? response.data.meta.total[1] : response.data.total || 0)
        commit('app/loading', false, { root: true })
      },
      () => {
        commit('app/loading', false, { root: true })
        commit('notifications', { title: 'Error al obtener las agrupaciones.', variant: 'danger' }, { root: true })
        commit('setShowNotifications', true, { root: true })
      },
    )
  },
  async updateGroupSchedule({ commit }, { id, data }) {
    commit('app/loading', true, { root: true })
    await scheduleApi.updateGroup(id, data).then(
      () => {
        commit('notifications', { title: 'Agrupación actualizada con éxito.', variant: 'success' }, { root: true })
        commit('setShowNotifications', true, { root: true })
        commit('app/loading', false, { root: true })
      },
      () => {
        commit('app/loading', false, { root: true })
        commit('notifications', { title: 'Error al actualizar la agrupación.', variant: 'danger' }, { root: true })
        commit('setShowNotifications', true, { root: true })
      },
    )
  },
  async getScheduleUsers({ commit }, id) {
    commit('app/loading', true, { root: true })
    await scheduleApi.getScheduleUsers(id).then(
      response => {
        commit('setScheduleGroupUsers', response.data.data || response.data)
        commit('app/loading', false, { root: true })
      },
      () => {
        commit('app/loading', false, { root: true })
        commit('notifications', { title: 'Error al obtener los usuarios del horario.', variant: 'danger' }, { root: true })
        commit('setShowNotifications', true, { root: true })
      },
    )
  },
  async getGroupScheduleUsers({ commit }, id) {
    commit('app/loading', true, { root: true })
    await scheduleApi.getGroupUsers(id).then(
      response => {
        commit('setScheduleGroupUsers', response.data.data || response.data)
        commit('app/loading', false, { root: true })
      },
      () => {
        commit('app/loading', false, { root: true })
        commit('notifications', { title: 'Error al obtener los usuarios de la agrupación.', variant: 'danger' }, { root: true })
        commit('setShowNotifications', true, { root: true })
      },
    )
  },
  async deleteGroupSchedule({ commit }, id) {
    commit('app/loading', true, { root: true })
    await scheduleApi.destroyGroup(id).then(
      () => {
        commit('notifications', { title: 'Agrupación eliminada con éxito.', variant: 'success' }, { root: true })
        commit('setShowNotifications', true, { root: true })
        commit('app/loading', false, { root: true })
      },
      () => {
        commit('app/loading', false, { root: true })
        commit('notifications', { title: 'Error al eliminar la agrupación.', variant: 'danger' }, { root: true })
        commit('setShowNotifications', true, { root: true })
      },
    )
  },
  async deleteSchedule({ commit }, id) {
    commit('app/loading', true, { root: true })
    await scheduleApi.destroy(id).then(
      () => {
        commit('notifications', { title: 'Horario eliminado con éxito.', variant: 'success' }, { root: true })
        commit('setShowNotifications', true, { root: true })
        commit('app/loading', false, { root: true })
      },
      () => {
        commit('app/loading', false, { root: true })
        commit('notifications', { title: 'Error al eliminar el horario.', variant: 'danger' }, { root: true })
        commit('setShowNotifications', true, { root: true })
      },
    )
  },
}

const getters = {
  getSchedule: state => state.schedule,
  getSchedules: state => state.schedules,
  getTotalSchedules: state => state.totalSchedules,
  getScheduleGroups: state => state.scheduleGroups,
  getTotalScheduleGroups: state => state.totalScheduleGroups,
  getScheduleGroupUsers: state => state.scheduleGroupUsers,
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
